import { Tab, Tabs, Row, Col, Form, Table } from "react-bootstrap";

import { defaultAssayMArkerColourSettings } from "../soil-assay/AssayQueryTool";
import { v4 as uuidv4 } from 'uuid';
import { faQuestionCircle, faMinus, faPlus, faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from "react";
import * as tokml from "@fulcrumapp/tokml"

export const defaultDrillHoleColourSettings = (
    [
        {
            id: uuidv4(),
            moreThan: 2.5,
            color: "#800080"
        },
        {
            id: uuidv4(),
            moreThan: 1,
            color: "#FF0000"
        },
        {
            id: uuidv4(),
            moreThan: 0.1,
            color: "#FFA500"
        },
        {
            id: uuidv4(),
            moreThan: 0,
            color: "#0000FF"
        }
    ]);







// hole type
function NumberInputField({ setValue, value }) {
    const [query, setQuery] = useState(value);

    useEffect(() => {
        if (query !== value) {

            const timeOutId = setTimeout(() => {
                setValue(query)
            }, 500);
            return () => clearTimeout(timeOutId);
        }
    }, [query]);


    useEffect(() => {
        setQuery(value);

    }, [value]);

    return (
        <>
            <Form.Control
                size="sm"
                type="number"
                value={query}
                step={0.01}
                onChange={event => setQuery(event.target.valueAsNumber)}
            />
        </>
    );
}

export function DrillHoleQueryTool({
    drillHoleFilters,
    setDrillHoleFilters,
    drillHoleColourSettings,
    setDrilHoleColourSettings,
    drillHoleGeoJson }) {


    // ANUMBER Search

    // Hole Type
    // "AC"
    //"AUG"
    //"COST"
    //"DD"
    //"MT"
    //"PERC"
    //"RAB"
    //"RC"
    //"RM"
    //"SON"
    //"UNKN"
    //"VAC"
    //"WAT"

    function markersToKml() {

        const exportGeoJson = drillHoleGeoJson;

        exportGeoJson.features = exportGeoJson.features.slice(0,500);

        exportGeoJson.features = exportGeoJson.features.map((m) => {
            m.properties.kml_title = "AU G/T: " + m.properties.au_gpt.toFixed(2);
            m.properties.description =
              "\n Unique ID: " + m.properties.dhassayid +
              "\n AU G/T: " + m.properties.au_gpt.toFixed(2) +
              "\n A Number : " + m.properties.anumber +
              "\n From Depth (Sample) : " + m.properties.fromdepth +
              "\n To Depth (Sample) : " + m.properties.todepth +
              "\n Max Depth (Hole) : " + m.properties.maxdepth +
              "\n Hole Type : " + m.properties.holetype +
              "\n Company Sample ID: " + m.properties.companysampleid;
      
            return m
          })

        var kml = tokml(exportGeoJson, { name: 'kml_title', description: 'description' });

        const url = window.URL.createObjectURL(new Blob([kml]));
        const link = document.createElement("a");
        link.href = url;
        link.download = "samples.kml";
        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

    }


    const setPpbLessThan = (val) => {
        setDrillHoleFilters({ ...drillHoleFilters, gptlt: val.target.valueAsNumber });
    }

    const setPpbMoreThan = (val) => {
        setDrillHoleFilters({ ...drillHoleFilters, gptmt: val.target.valueAsNumber });
    }

    const setMaxDepth = (val) => {
        setDrillHoleFilters({ ...drillHoleFilters, maxDepth: val.target.valueAsNumber });
    }

    const removeRangeEntry = (id) => {

        setDrilHoleColourSettings(drillHoleColourSettings.filter((setting) => {
            if (setting.id !== id) {
                return true;
            } else return false;
        }))
    }

    const addRangeEntry = () => {

        setDrilHoleColourSettings([...drillHoleColourSettings, {
            id: uuidv4(),
            moreThan: 1234,
            color: "black"
        }])

    }

    const updateMoreThanValue = (id, value) => {
        const arr = drillHoleColourSettings.map((e) => {
            if (e.id === id) {
                e.moreThan = value;//value.target.valueAsNumber;
            }
            return e;
        });
        setDrilHoleColourSettings([...arr]);
    }

    const updateColourValue = (id, value) => {

        const arr = drillHoleColourSettings.map((e) => {
            if (e.id === id) {
                e.color = value.target.value;
            }
            return e;
        });
        setDrilHoleColourSettings([...arr]);
    }


    const to3dp = (number) => {
        return number.toFixed(2)
    }

    const AssayMarkerColourDisplay = (assayMarkerColourSettings) => {


        const orderedAssayMarkerArray = assayMarkerColourSettings.toSorted((a, b) => b.moreThan - a.moreThan);


        // there is an issue here - for whatever reason it causes a large amount of re-draws?

        const rows = [];
        for (let i = 0; i < orderedAssayMarkerArray.length; i++) {


            const next = i - 1;
            rows.push(
                <tr>
                    <td style={{ textAlign: 'right' }}>
                        <button onClick={e => removeRangeEntry(orderedAssayMarkerArray[i].id)} className='btn btn-danger btn-sm '>
                            <FontAwesomeIcon icon={faMinus} />
                        </button>
                    </td>
                    <td style={{ textAlign: 'center' }}>
                        <input type="color" id="head"

                            onChange={val => {
                                updateColourValue(orderedAssayMarkerArray[i].id, val)
                            }}
                            name="head" value={orderedAssayMarkerArray[i].color} />
                    </td>
                    <td>
                        <Row>
                            <Col>
                                <NumberInputField
                                    id={'val' + orderedAssayMarkerArray[i].id}
                                    value={orderedAssayMarkerArray[i].moreThan}
                                    setValue={val => {
                                        updateMoreThanValue(orderedAssayMarkerArray[i].id, val)
                                    }}
                                />
                            </Col>
                            <Col>
                                <Form.Label column="sm">
                                    To  {i !== 0 ? to3dp(orderedAssayMarkerArray[next].moreThan - 0.01) : "9999"}
                                </Form.Label>
                            </Col>
                        </Row>

                    </td>
                </tr>
            );
        }

        return rows;
    }

    return <>
        <Tabs
            id="uncontrolled-tab-example"
            className="mb-3"
        >
            <Tab eventKey="simple" title="Simple">

                <Row className='mb-2'>
                    <Col>
                        <Form.Label column="sm" style={{ fontSize: 12 }}>Grams Per Tonne Less than:</Form.Label>
                        <FontAwesomeIcon
                            title="Gold grams per tonne"
                            style={{ marginLeft: 5 }}
                            icon={faQuestionCircle} />
                    </Col>
                    <Col>
                        <Form.Control
                            size="sm"
                            defaultValue={drillHoleFilters.gptlt}
                            type='number'
                            onChange={setPpbLessThan}
                            step="0.1"
                            required />
                    </Col>
                </Row>

                <Row className='mb-2'>
                    <Col>
                        <Form.Label column="sm" style={{ fontSize: 12 }}>Grams Per Tonne More than:</Form.Label>
                        <FontAwesomeIcon
                            title="Gold grams per tonne"
                            style={{ marginLeft: 5 }}
                            icon={faQuestionCircle} />
                    </Col>
                    <Col>
                        <Form.Control
                            size="sm"
                            defaultValue={drillHoleFilters.gptmt}
                            onChange={setPpbMoreThan}
                            type='number'
                            step="0.1"
                            required />
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col>
                        <Form.Label column="sm" style={{ fontSize: 12 }}>Max Depth:</Form.Label>
                        <FontAwesomeIcon
                            title="Maximum Depth of Drill Hole to Analyse. NOTE: Maximum Queryable Hole Depth is 50m"
                            style={{ marginLeft: 5 }}
                            icon={faQuestionCircle} />
                    </Col>
                    <Col>
                        <Form.Control
                            size="sm"
                            defaultValue={drillHoleFilters.maxDepth}
                            onChange={setMaxDepth}
                            type='number'
                            step="1"
                            required />
                    </Col>
                </Row>
            </Tab>
            <Tab eventKey="legend" title="Legend">
                <Table striped bordered >
                    <thead>
                        <tr>
                            <th style={{ width: '10%' }}></th>
                            <th style={{ width: '20%' }} >Colour</th>
                            <th>Range</th>
                        </tr>
                    </thead>
                    <tbody>
                        {AssayMarkerColourDisplay(drillHoleColourSettings)}
                    </tbody>
                    <button style={{ margin: 10 }} onClick={addRangeEntry} className='btn btn-success btn-sm '>
                        <i className='fa fa-solid fa-plus'></i>
                    </button>
                    <button style={{ margin: 10 }} onClick={(e) => {
                        setDrilHoleColourSettings(defaultAssayMArkerColourSettings)
                    }} className='btn btn-warning btn-sm '>
                        Reset
                    </button>


                </Table>
            </Tab>

        </Tabs>
        <Col className='text-center mb-1'  >
            <button className="btn btn-secondary btn-sm" onClick={markersToKml}>Export results to KML file</button>
        </Col>
        <Col className='text-center mb-3'  >
            Note: Export is limited to top 500 samples
        </Col>
    </>
}